<template>
  <div class="seats-chart" :class="className" v-inview="{ callback: onInview }">
    <div class="seats-chart__map">
      <div class="seats-chart__grids"><!--
      --><div class="seats-chart__grid"
          v-for="(gid, gIndex) in totalGrids"
          :key="`grid-${gIndex}`"
          :title="`grid-${gIndex}`">
        </div>
      </div>
      <div class="seats-chart__seats"><!--
      --><div class="seats-chart__seat"
          v-for="seat in data"
          :key="`seat-${seat.id}`"
          :style="renderSeatStyle(seat)"
          @click="onSeatClick(seat)">
            <div class="seats-chart__seat-icon"
              :style="renderSeatIconStyle(seat)">
            </div>
        </div>
      </div>
      <transition name="tween-info">
        <div class="seats-chart__info" v-show="activeGroupInfo.length">
          <button class="seats-chart__info-close" @click="onInfoCloseClick"><SvgSymbol use="#clear"/></button>
          <table class="seats-chart__table">
            <caption class="seats-chart__table-caption">{{ groups[activeGroupInfoIndex] }}</caption>
            <thead class="seats-chart__table-head">
              <tr class="seats-chart__table-row" :style="`background-color: ${activeGroupColor}`">
                <th class="seats-chart__table-col seats-chart__table--label"></th>
                <th class="seats-chart__table-col seats-chart__table--label">分區</th>
                <th class="seats-chart__table-col seats-chart__table--label">不分區</th>
              </tr>
            </thead>
            <tbody class="seats-chart__table-body">
              <tr class="seats-chart__table-row">
                <td class="seats-chart__table-col seats-chart__table--label">總得票數</td>
                <template v-if="year > rulesChageYear">
                  <td class="seats-chart__table-col" v-for="({ votes }, votesIndex) in activeGroupInfo" :key="`votes-${votesIndex}`">
                    {{ votes | numeric }}
                  </td>
                </template>
                <template v-else>
                  <td colspan="2" class="seats-chart__table-col" v-for="({ votes }, votesIndex) in activeGroupInfo.slice(0, 1)" :key="`votes-${votesIndex}`">
                    {{ votes | numeric }}
                  </td>
                </template>
              </tr>
              <tr class="seats-chart__table-row">
                <td class="seats-chart__table-col seats-chart__table--label">總得票數</td>
                <template v-if="year > rulesChageYear">
                  <td class="seats-chart__table-col" v-for="({ proportion }, votesIndex) in activeGroupInfo" :key="`proportion-${votesIndex}`">
                    {{ proportion | percentage }}
                  </td>
                </template>
                <template v-else>
                  <td colspan="2" class="seats-chart__table-col" v-for="({ proportion }, votesIndex) in activeGroupInfo.slice(0, 1)" :key="`proportion-${votesIndex}`">
                    {{ proportion | percentage }}
                  </td>
                </template>
              </tr>
              <tr class="seats-chart__table-row">
                <td class="seats-chart__table-col seats-chart__table--label">席次</td>
                <td class="seats-chart__table-col" v-for="({ seats }, votesIndex) in activeGroupInfo" :key="`seats-${votesIndex}`">
                  {{ seats }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </transition>
    </div>
    <ul class="seats-chart__roles"><!--
    --><li class="seats-chart__roles-group" v-for="(roleGroup, rgIndex) in rolesInfo" :key="`role-gorup-${rgIndex}`">
        <div class="seats-chart__roles-item" v-for="(role, rIndex) in roleGroup" :key="`role-${rgIndex}-${rIndex}`"><!--
        --><span class="seats-chart__role-icon" :style="renderSeatRoleIconStyle(role)"></span><!--
        --><span class="seats-chart__role-name">{{ role.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Easystar from 'easystarjs'
import { randArray } from '@/scripts/utils'

export default {
  name: 'SeatsChart',
  props: {
    year: { type: Number, required: true },
    values: { type: Array, default: () => [] },
    votes: { type: Array, default: () => [] },
    proportions: { type: Array, default: () => [] },
    colors: { type: Array, default: () => [] },
    groups: { type: Array, default: () => [] },
    roles: { type: Array, default: () => [] }
  },
  data () {
    return {
      isInview: false,
      data: null,
      // seatsPerRow: 12,
      collisions: null,
      guider: null,
      playTime: 0,
      playIndexRange: 0,
      activeGroupInfoIndex: null,
      rulesChageYear: 2004
    }
  },
  computed: {
    isLargeMap () {
      return this.totalSeats > 113
    },
    className () {
      return {
        'seats-chart--inview': this.isInview,
        'seats-chart--crowd': this.isLargeMap
      }
    },
    seatsPerRow () {
      return this.isLargeMap ? 16 : 12
    },
    groupValues () {
      return this.values.map(value => value.reduce((sum, value) => sum + value, 0))
    },
    totalSeats () {
      return this.groupValues.reduce((sum, value) => sum + value, 0)
    },
    totalGrids () {
      return this.seatsPerRow * this.maxRows
    },
    seatsPerRowByGroups () {
      let arr = this.groupValues.map(value => {
        const percent = Number((value / this.totalSeats).toFixed(4))
        const proportion = percent * this.seatsPerRow
        const seats = Math.round(proportion)
        console.log(`${percent} x ${this.seatsPerRow} = ${proportion} = ${seats}`)
        return proportion < 1 ? 1 : seats
      })
      let sum = arr.reduce((sum, seats) => sum + seats, 0)
      let offset = sum - this.seatsPerRow
      let seatsMaxValue = Math.max(...arr)
      let seatsMaxIndex = arr.indexOf(seatsMaxValue)
      let seatsMinValue = Math.min(...arr)
      let seatsMinIndex = arr.indexOf(seatsMinValue)
      console.log(`seatsPerRowByGroups = ${arr}`)
      if (offset > 0) {
        console.warn(`[computed] "seatsPerRowByGroups" sum = ${sum} is more(${offset}) than ${this.seatsPerRow}, auto resolve done`)
        arr[seatsMaxIndex] -= offset
      } else if (offset < 0) {
        console.warn(`[computed] "seatsPerRowByGroups" sum = ${sum} is less(${offset}) than ${this.seatsPerRow}, auto resolve done`)
        arr[seatsMinIndex] -= offset
      }
      console.log(`seatsPerRowByGroups = ${arr}`)
      return [ ...arr ]
    },
    maxRows () {
      let defaultRows = Math.ceil(this.totalSeats / this.seatsPerRow)
      let rowsByGroups = this.groupValues.map((value, index) => {
        const seatsPerRowInGroup = this.seatsPerRowByGroups[index]
        return Math.ceil(value / seatsPerRowInGroup)
      })
      return Math.max(...[defaultRows].concat(rowsByGroups))
    },
    seats () {
      let id = 0
      const seats = this.values
        .map((group, groupIndex) => {
          let lastIndexInGroup = 0
          const seatsGroupOffsetX = this.seatsPerRowByGroups
            .slice(0, groupIndex)
            .reduce((sum, offset) => sum + offset, 0)
          return group.map((value, valueIndex) => {
            const color = this.colors[groupIndex][valueIndex]
            const seatsPerRowInGroup = this.seatsPerRowByGroups[groupIndex]
            const arr = [ ...Array(value) ].map((_, index) => {
              const indexInGroup = index + lastIndexInGroup
              const usePathAnimation = indexInGroup % 3 === 0
              const opacity = 0
              const originX = Math.round((this.seatsPerRow - 1) * Math.random())
              const originY = Math.floor((this.maxRows - 1) / 2)
              const destX = (indexInGroup % seatsPerRowInGroup) + seatsGroupOffsetX
              const destY = Math.floor(indexInGroup / seatsPerRowInGroup)
              const origin = { x: originX, y: originY }
              const render = usePathAnimation ? { x: originX, y: originY } : { x: destX, y: destY }
              const dest = { x: destX, y: destY }
              const isDone = false
              return {
                id: id++,
                group: groupIndex,
                color,
                opacity,
                origin,
                render,
                dest,
                isDone
              }
            })
            lastIndexInGroup += value
            return [ ...arr ]
          })
        })
      return this.flatten(seats)
    },
    activeGroupColor () {
      if (this.activeGroupInfoIndex !== null) {
        return this.colors[this.activeGroupInfoIndex][0]
      }
      return '#a7a7a7'
    },
    activeGroupInfo () {
      return this.values.map((group, groupIndex) => {
        return group.map((value, valueIndex) => {
          const seats = value
          const votes = this.votes[groupIndex][valueIndex]
          const proportion = this.proportions[groupIndex][valueIndex]
          return {
            seats,
            votes,
            proportion
          }
        })
      })[this.activeGroupInfoIndex] || []
    },
    rolesInfo () {
      return this.roles.map((group, groupIndex) => {
        return group.map((role, index) => {
          const name = role
          const color = this.colors[groupIndex][index]
          return { name, color }
        })
      })
    }
  },
  methods: {
    onInview () {
      this.isInview = true
      this.playback()
    },
    onSeatClick (seat) {
      const { group } = seat
      if (this.activeGroupInfoIndex === group) {
        return
      }
      this.activeGroupInfoIndex = group
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Read',
        'eventAction': 'Click',
        'eventLabel': 'PartyVotes'
      })
    },
    onInfoCloseClick () {
      this.activeGroupInfoIndex = null
    },
    flatten (arr) {
      if (!Array.isArray(arr)) {
        return arr
      }
      return arr.reduce((result, data) => result.concat(!Array.isArray(data) ? data : this.flatten(data)), [])
    },
    renderSeatStyle ({ render, opacity }) {
      const { x, y } = render
      const transform = `translate(${x * 100}%, ${y * 100}%)`
      return {
        transform,
        opacity
      }
    },
    renderSeatIconStyle ({ group, color }) {
      const style = {}
      style.backgroundColor = color
      console.log()
      if (this.activeGroupInfoIndex !== null && this.activeGroupInfoIndex !== group) {
        style.transform = `translate(-50%, -50%) scale(0.5)`
      }
      return { ...style }
    },
    renderSeatRoleIconStyle ({ color }) {
      return {
        'background-color': color
      }
    },
    initData () {
      this.data = randArray(JSON.parse(JSON.stringify(this.seats)))
        .map(seat => {
          const { id, render, dest } = seat
          let steps = []
          const task = this.guider.findPath(render.x, render.y, dest.x, dest.y, (path) => {
            if (!path) {
              console.warn('[initData] path finding task is stuck on', id)
              return
            }
            steps = path.slice(1) // the first one step is origin position
          })
          this.guider.calculate()
          this.guider.cancelPath(task)
          return {
            ...seat,
            steps
          }
        })
    },
    updateData (range = 0) {
      // console.log('update seats data')
      this.data = this.data.map((seat, index) => {
        let isDone = seat.isDone
        if (isDone || index > range) {
          return seat
        }
        let { id, group, color, opacity, origin, render, dest, steps } = seat
        const nextStep = steps.length > 0 ? steps.shift() : dest
        const { x, y } = nextStep
        render.x = x
        render.y = y
        opacity = 1
        isDone = !steps.length
        return { id, group, color, opacity, origin, render, dest, steps, isDone }
      })
      return !this.data.some(seats => !seats.isDone)
    },
    playback (time) {
      let canUpdate = false
      if (!time) {
        canUpdate = true
      } else {
        let dt = time - this.playTime
        if (dt >= 250) { // 200 + 50 (buffer time for edge|ie11)
          canUpdate = true
          this.playTime = time
        }
      }
      // calculate
      let isFinished = false
      if (canUpdate) {
        isFinished = this.updateData(this.playIndexRange)
        this.playIndexRange += 10
      }
      // play next frame
      if (!isFinished) {
        requestAnimationFrame(this.playback)
      }
    }
  },
  created () {
    this.collisions = [...Array(this.maxRows + 1)]
      .map(() => [...Array(this.seatsPerRow + 1)].map(() => 0))
    /* eslint-disable no-new, new-cap */
    this.guider = new Easystar.js()
    this.guider.setGrid(this.collisions)
    this.guider.setAcceptableTiles([0])
    // this.guider.enableDiagonals()
    // this.guider.enableCornerCutting()
    this.guider.enableSync()
    this.initData()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss">
.seats-chart {
  $comp: &;
  $unit: 0.0833 * 100%; // col=12

  &__map {
    position: relative;
    overflow: hidden;
  }

  &__grids {
    position: relative;
    line-height: 1em;
    // outline: 1px solid cyan;
  }

  &__grid {
    display: inline-block;
    position: relative;
    width: $unit;
    vertical-align: top;
    // outline: 1px dashed #e1e1e1;
    @include use-fixed-ratio(1, 1);

    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18px;
      height: 18px;
      // background: #e1e1e1;
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__seats {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__seat {
    position: absolute;
    width: $unit;
    text-align: center;
    line-height: 1em;
    cursor: pointer;
    backface-visibility: hidden;
    transition:
      transform 0.2s linear,
      opacity 0.2s ease;
    @include use-fixed-ratio(1, 1);

    &-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18px;
      height: 18px;
      background: gray;
      border-radius: 50%;
      transform: translate(-50%, -50%);
      transition: transform 0.3s;
      @include rwd($RWD_TABLET_SMALL) {
        width: 24px;
        height: 24px;
      }
      @include rwd($RWD_TABLET) {
        width: 28px;
        height: 28px;
      }
      @include rwd($RWD_DESKTOP_1440) {
        width: 34px;
        height: 34px;
      }
    }
  }

  &__info {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    max-width: 450px;
    padding: 26px 10px;
    background: white;
    border: 1px solid #1a1a1a;
    border-radius: 2px;
    transform: translate(-50%, -50%);

    &-close {
      position: absolute;
      top: 15px;
      right: 10px;
      width: 20px;
      height: 20px;
      color: white;
      background: #1a1a1a;
      border-radius: 50%;
      cursor: pointer;

      &:active {
        transform: translateY(1px);
      }

      .svg-symbol {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 16px;
        height: 16px;
        margin: -8px 0 0 -8px;
      }
    }
  }

  &__table {
    $comp: &;
    width: 100%;

    &-caption {
      margin-bottom: 15px;
      font-weight: 500;
      text-align: left;
      text-indent: 13px;
    }

    &-head {
      #{$comp}-row {
        color: white;
        background: #a7a7a7;
        transition: background-color 0.3s;
      }

      #{$comp}-col {
        font-weight: 500;
        border-top: none;
      }
    }

    &-body {
    }

    &-row {
      background: #efefef;

      &:nth-of-type(2n) {
        background: #e6e6e6;
      }
    }

    &-col {
      width: 30%;
      padding: 10px 0;
      line-height: 1em;
      text-align: center;
      border: 1px solid white;

      & + & {
        width: 35%;
      }
    }

    &--label {
      font-size: 0.8125em;
    }
  }

  &__roles {
    margin-top: 17px;
    padding: 13px 0 13px 17px;
    background: white;
    opacity: 0;
    transform: translateY(10px);
    transition:
      opacity 0.3s ease 0.8s,
      transform 0.4s ease 0.8s;
  }

  &__roles-group {
    display: inline-block;
    width: 33.33%;
    opacity: 0;
    transform: translateX(10px);
    transition:
      opacity 0.3s,
      transform 0.4s;
  }

  &__roles-item {
    line-height: 1em;
    @include use-vertical-align();
    & + & {
      margin-top: 5px;
    }
  }

  &__role-icon {
    display: inline-block;
    width: 12px;
    height: 12px;
    vertical-align: middle;
    background-color: #a7a7a7;
    border-radius: 50%;
  }

  &__role-name {
    margin-left: 4px;
    color: #a7a7a7;
    font-size: 0.75em;
    vertical-align: middle;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 0.8125em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 0.875em;
    }
  }

  // vue transitions
  .tween-info {
    &-enter-active {
      transition:
        opacity 0.3s,
        transform 0.3s;
    }
    &-leave-active {
      transition: none;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
      transform: translate(-50%, -45%);
    }

    &-enter-to,
    &-leave {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }
}

.seats-chart {
  $comp: &;
  $unit: 0.0625 * 100%; // col=16

  &--inview {
    #{$comp}__roles {
      opacity: 1;
      transform: translateY(0);
    }
    #{$comp}__roles-group {
      opacity: 1;
      transform: translateX(0);
      &:nth-child(1) {
        transition-delay: 1s;
      }
      &:nth-child(2) {
        transition-delay: 1.25s;
      }
      &:nth-child(3) {
        transition-delay: 1.5s;
      }
    }
  }

  &--crowd {
    #{$comp}__grid {
      width: $unit;

      &:after {
        display: none;
      }
    }

    #{$comp}__seat {
      width: $unit;

      &-icon {
        width: 14px;
        height: 14px;
        @include rwd($RWD_TABLET_SMALL) {
          width: 16px;
          height: 16px;
        }
        @include rwd($RWD_TABLET) {
          width: 18px;
          height: 18px;
        }
        @include rwd($RWD_TABLET) {
          width: 20px;
          height: 20px;
        }
        @include rwd($RWD_DESKTOP_1440) {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}
</style>
